import axios from "axios";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return String(d);
};

export const money = (minor, currency = "ngn") => {
  const sym = currency === "usd" ? "$" : "₦";
  return `${sym}${((minor || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

export const PAYMENT_STATES = {
  CREATED: "Awaiting payment", PENDING: "Awaiting provider confirmation", CONFIRMED: "Payment confirmed",
  ALLOCATED: "Allocated", UPFRONT_PAYOUT_PENDING: "Upfront tranche pending", PARTIALLY_SETTLED: "20% settled · work in progress",
  COMPLETION_SUBMITTED: "Completion submitted", UNDER_REVIEW: "Client review", DISPUTED: "Disputed · payout on hold",
  FINAL_PAYOUT_PENDING: "Final payout pending", SETTLED: "Fully settled", REFUND_PENDING: "Refund pending",
  PARTIALLY_REFUNDED: "Partially refunded", REFUNDED: "Refunded", FAILED: "Payment failed", CANCELLED: "Cancelled",
};

export const stateTone = (s) => {
  if (["SETTLED", "PARTIALLY_SETTLED", "CONFIRMED", "active", "closed", "completed", "paid", "approved", "committed", "matched"].includes(s))
    return "bg-turquoise/10 text-turquoise border-turquoise/30";
  if (["DISPUTED", "FAILED", "failed", "escalated", "disputed", "exception", "blocked_insufficient_funds", "rejected"].includes(s))
    return "bg-red-400/10 text-red-300 border-red-400/30";
  if (["CANCELLED", "REFUNDED", "cancelled", "refunded"].includes(s)) return "bg-white/5 text-white/55 border-white/15";
  return "bg-gold-400/10 text-gold-200 border-gold-400/30";
};

export const Pill = ({ value, label, testId }) => (
  <span data-testid={testId} className={`inline-flex px-2.5 py-0.5 rounded-full border font-montserrat text-[10px] uppercase tracking-wider ${stateTone(value)}`}>
    {label || PAYMENT_STATES[value] || String(value || "—").replace(/_/g, " ")}
  </span>
);

export const trackEvent = (event, props = {}) => http.post("/analytics/track", { event, ...props }).catch(() => {});

export const inputCls =
  "w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 font-inter text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-turquoise/60 transition-colors";

export const labelCls = "font-montserrat text-[10px] uppercase tracking-[0.2em] text-white/50 mb-2 block";
